const app = require('js/app')

module.exports = app.config(['$stateProvider', '$urlRouterProvider',
  function($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('', '/login')

    $stateProvider
      .state('login', {
        url: '/login',
        template: require('views/login/login.html'),
        controller: 'LoginCtrl'
      })
      .state('bindAuth', {
        url: '/bindAuth?redirectUrl',
        template: require('views/login/bindAuth.html'),
        controller: 'LoginCtrl'
      })
      .state('emailValidation', {
        url: '/emailValidation',
        cache: true,
        template: require('views/login/forgetPassword/emailValidation.html'),
        controller: 'forgetPasswordCtrl',
      })
      .state('getPasswordViaPhone', {
        url: '/getPasswordViaPhone',
        cache: true,
        template: require('views/login/forgetPassword/getPasswordViaPhone.html'),
        controller: 'forgetPasswordCtrl'
      })
      .state('resetPassword', {
        url: '/resetPassword',
        cache: true,
        template: require('views/login/forgetPassword/resetPassword.html'),
        controller: 'forgetPasswordCtrl'
      })
      .state('intro', {
        url: '/intro',
        template: require('views/common/intro.html'),
        controller: 'introCtrl'
      })
      .state('forbid', {
        url: '/forbid?reason',
        template: require('views/common/forbid.html'),
        controller: ['$scope', '$stateParams', function($scope, $stateParams) { $scope.reason = $stateParams.reason }]
      })
      .state('frame', {
        url: '/frame?sid&redirectUrl',
        abstract: true,
        template: require('views/frame.html'),
        resolve: {data: require('js/controllers/frameInitCtrl')}
      })
      .state('frame.folder', {
        url: '/folder/:fid',
        views: {
          'content': {
            template: require('views/mail/messages-bars.html'),
            controller: 'mailFolderCtrl'
          }
        }
      })
      .state('frame.read', {
        url: '/read/:fid/:mid?type&mboxa',
        views: {
          'content': {
            template: require('views/mail/read.html'),
            controller: 'readCtrl'
          }

        }
      })
      .state('frame.readDealing', {
        /** todo: 应该和完全可以和 frame.read 用同一个路由 */
        url: '/read/:fid/:mid/:keyword/:selectedTag/:name/:random/:isMailDealings?mboxa',
        views: {
          'content': {
            template: require('views/mail/read.html'),
            controller: 'readCtrl'
          }

        }
      })
      .state('frame.compose', {
        url: '/compose/:action/:mid/:email?mboxa',
        views: {
          'content': {
            template: require('views/compose/compose.html'),
            controller: 'composeCtrl'
          }
        },
        cache: false
      })
    /* ---------------------------------------------------------------- */
      .state('frame.netFolder', { // 文件中心入口
        cache: false,
        url: '/netFolder',
        views: {
          'content': {
            template: require('views/netFolder/index.html'),
            controller: 'netFolderCtrl'
          }

        }
      })
      .state('frame.nfList', { // 个人网盘或企业网盘列表页面
        cache: false,
        url: '/nfList/:type/:path',
        views: {
          'content': {
            template: require('views/netFolder/nfList.html'),
            controller: 'nfListCtrl'
          }

        }
      })
      .state('frame.fileDetail', {
        url: '/fileDetail/:type/:mid',
        views: {
          'content': {
            template: require('views/netFolder/fileDetail.html'),
            controller: 'fileDetailCtrl'
          }
        }
      })
      .state('frame.schedule', {
        cache: false,
        url: '/schedule',
        views: {
          'content': {
            template: require('views/schedule/schedule.html'),
            controller: 'scheduleCtrl'
          }
        }
      })
      .state('frame.addressbook', {
        url: '/addressbook',
        views: {
          'content': {
            template: require('views/addressBook/address.html')
          }
        }
      })
      .state('frame.contactList', {
        cache: false,
        url: '/contactList/:path',
        views: {
          'content': {
            template: require('views/addressBook/contactList.html'),
            controller: 'contactListCtrl'
          }
        }
      })
      .state('frame.personalContact', {
        cache: false,
        url: '/personalContact/:type',
        views: {
          'content': {
            template: require('views/addressBook/personalContact.html'),
            controller: 'personalContactCtrl'
          }
        }
      })
      .state('frame.personalContactList', {
        cache: false,
        url: '/personalContactList/:groupid/:useCache/:opeType',
        views: {
          'content': {
            template: require('views/addressBook/personalContactList.html'),
            controller: 'personalContactCtrl'
          }
        }
      })
      .state('frame.createContact', {
        cache: false,
        url: '/createContact/:type/:contactid/:name',
        views: {
          'content': {
            template: require('views/addressBook/createContact.html'),
            controller: 'createContactGroupCtrl'
          }
        }
      })
      .state('frame.createGroup', {
        cache: false,
        url: '/createGroup/:type/:groupid/:total/:random',
        views: {
          'content': {
            template: require('views/addressBook/createGroup.html'),
            controller: 'createContactGroupCtrl'
          }
        }
      })
      .state('frame.selectMemberResult', {
        url: '/selectMemberResult',
        views: {
          'content': {
            template: require('views/addressBook/selectMemberResult.html'),
            controller: 'createContactGroupCtrl'
          }
        }
      })
      .state('frame.personalContactDetail', {
        cache: false,
        url: '/personalContactDetail/:groupid/:contactid',
        views: {
          'content': {
            template: require('views/addressBook/personalContactDetail.html'),
            controller: 'detailCtrl'
          }
        }
      })
      .state('frame.detail', {
        url: '/detail/:contactId/:name',
        views: {
          'content': {
            template: require('views/addressBook/detail.html'),
            controller: 'detailCtrl'
          }
        }
      })
      .state('frame.maildealings', {
        url: '/mailDealings/:contactId/:name',
        views: {
          'content': {
            template: require('views/mail/mail-dealings.html'),
            controller: 'mailDealingCtrl'
          }
        }
      })
      .state('frame.setting', {
        url: '/setting/',
        views: {
          'content': {
            template: require('views/setting/settingIndex.html'),
            controller: 'settingCtrl'
          }
        }
      })
      .state('frame.languageSetup', {
        url: '/languageSetup/',
        views: {
          'content': {
            template: require('views/setting/languageSetup.html'),
            controller: 'settingCtrl'
          }
        }
      })
      .state('frame.sharedMailbox', {
        url: '/sharedMailbox/',
        cache: false,
        views: {
          'content': {
            template: require('views/setting/sharedMailbox/sharedMailbox.html'),
            controller: 'sharedMailboxCtrl'
          }
        }
      })
      .state('frame.changePassword', {
        url: '/changePassword/:secondAuthTempSid',
        cache: false,
        views: {
          'content': {
            template: require('views/setting/changePassword/changePassword.html'),
            controller: 'changePasswordCtrl'
          }
        }
      })
      .state('frame.auth', {
        cache: false,
        url: '/auth/:email/:type/:params',
        views: {
          'content': {
            template: require('views/verification/verificationConfirm.html'),
            controller: 'authCtrl'
          }
        }
      })
      .state('frame.loginReminding', {
        url: '/loginreminding/:uid/:loginClient/:loginTime',
        views: {
          'content': {
            template: require('views/components/loginReminding.html'),
            controller: 'loginRemindingCtrl'
          }
        }
      })
  }])



// WEBPACK FOOTER //
// ./src/js/routes.js